import type { CoupleNameOrder } from "../types/wedding";

type CoupleNames = {
  brideFirstName?: string | null;
  groomFirstName?: string | null;
  coupleNameOrder?: CoupleNameOrder | null;
};

export const getOrderedCoupleFirstNames = ({
  brideFirstName,
  groomFirstName,
  coupleNameOrder,
}: CoupleNames): string[] => {
  const names =
    coupleNameOrder === "groom-first"
      ? [groomFirstName, brideFirstName]
      : [brideFirstName, groomFirstName];

  return names.filter((name): name is string => Boolean(name?.trim()));
};

export const getCoupleDisplayName = (
  names: CoupleNames,
  separator = " & ",
): string => getOrderedCoupleFirstNames(names).join(separator);
